import styled from 'styled-components';
var CurrencySymbol = styled.span.withConfig({
  displayName: "CurrencySymbolstyles__CurrencySymbol",
  componentId: "sc-1d2g5pb-0"
})([""]);
export var Styled = {
  CurrencySymbol: CurrencySymbol
};